<template>
  <div class="wrapper">
    <Header class="black"></Header>

    <div class="main">
      <div class="banner">
        <img src="../../assets/images/publish_banner.png"/>
      </div>

      <div class="container">
        <div class="form">
          <div class="title">
            <span>发布意向单</span>
          </div>

          <div class="content">
            <dl class="clearfix video-type">
              <dt>视频类型</dt>
              <dd class="f0">
                <a href="javascript:;" class="btn" :class="{active: videoType == 1}" @click="onVideoType(1)">产品</a>
                <a href="javascript:;" class="btn" :class="{active: videoType == 2}" @click="onVideoType(2)">品牌</a>
                <a href="javascript:;" class="btn" :class="{active: videoType == 3}" @click="onVideoType(3)">企业</a>
                <a href="javascript:;" class="btn" :class="{active: videoType == 4}" @click="onVideoType(4)">个人</a>
                <a href="javascript:;" class="btn" :class="{active: videoType == 5}" @click="onVideoType(5)">活动</a>
                <a href="javascript:;" class="btn" :class="{active: videoType == 6}" @click="onVideoType(6)">城市</a>
                <a href="javascript:;" class="btn" :class="{active: videoType == 7}" @click="onVideoType(7)">其他</a>
              </dd>
            </dl>

            <dl class="clearfix video-tiem">
              <dt>影片时长</dt>
              <dd>
                <a href="javascript:;" class="btn" :class="{active: videoTime == 1}" @click="onVideoTime(1)">30秒以内</a>
                <a href="javascript:;" class="btn" :class="{active: videoTime == 2}" @click="onVideoTime(2)">30～60秒</a>
                <a href="javascript:;" class="btn" :class="{active: videoTime == 3}" @click="onVideoTime(3)">60～120秒</a>
                <a href="javascript:;" class="btn" :class="{active: videoTime == 4}" @click="onVideoTime(4)">120秒以上</a>
              </dd>
            </dl>

            <dl class="clearfix budget">
              <dt>项目预算</dt>
              <dd>
                <div>
                  <a href="javascript:;" class="btn btn-big" :class="{active: budget == 1}" @click="onBudget(1)">5000元以内</a>
                  <a href="javascript:;" class="btn btn-big" :class="{active: budget == 2}" @click="onBudget(2)">5000～10000元</a>
                  <a href="javascript:;" class="btn btn-big" :class="{active: budget == 3}" @click="onBudget(3)">10000～50000元</a>
                  <a href="javascript:;" class="btn btn-big" :class="{active: budget == 4}" @click="onBudget(4)">50000～100000元</a>
                  <a href="javascript:;" class="btn btn-big" :class="{active: budget == 5}" @click="onBudget(5)">100000元以上</a>
                </div>
                <div class="tips"><a href="valuer.html" target="_blank">不清楚视频价格？来估个价吧～</a></div>
              </dd>
            </dl>

            <dl class="clearfix date">
              <dt>成片时间</dt>
              <dd>
                <DatePicker type="date" placeholder="请选择成片时间" format="yyyy-MM-dd" :options="pickerOptions" v-model="endTime" style="width: 400px;"></DatePicker>
              </dd>
            </dl>

            <dl class="clearfix">
              <dt>联系电话</dt>
              <dd>
                <input type="text" placeholder="请输入联系电话" maxlength="11" v-model="mobile"/>
              </dd>
            </dl>

            <dl class="clearfix code">
              <dt>短信验证码</dt>
              <dd class="f0">
                <input type="text" placeholder="请输入验证码" v-model="code"/>
                <button class="btn" @click="onSendCode" :disabled="codeBtn.state == 1">{{codeBtn.text}}</button>
              </dd>
            </dl>
            <div style="margin: 0 auto; width: 1000px; font-size: 12px;">&nbsp;*意向单提交成功后，会有工作人员与您电话沟通</div>
          </div>

          <div class="foot">
            <div>
              <button class="btn btn-default" @click="onSubmitPublish">提交</button>
              <a href="index.html" class="btn btn-empty">取消</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--提示框-->
    <Modal v-model="modal.m1" title="提示" class="model" width="480">
      <div style="padding: 10px 0; font-size: 16px; color:#424753; font-weight: 400; text-align:center;">
        <p>检测到此手机号已注册，是否登录趣编网？</p>
      </div>
      <div slot="footer" style="padding:10px 0; text-align: center;">
        <Button class="btn btn-default" style="margin-right: 30px;" @click="m1(true)">登录</Button>
        <Button class="btn btn-empty" @click="m1(false)">不登录</Button>
      </div>
    </Modal>

    <Modal v-model="modal.m2" title="提示" class="model" width="480">
      <div style="padding: 10px 88px; font-size: 16px; color:#424753; font-weight: 400; text-align:center;">
        <p>您好，检测到此手机号未注册，<br/>提交意向单即使用此手机号自动注册。</p>
        <p style="margin-top:20px; font-size: 12px;">
          <label>
            <input type="checkbox" v-model="modal.agree"/>
            <i class="icon"></i>
            已阅读并接受
          </label>
          <a href="agreement.html" target="_blank" style="color: #5C8DDE;">《趣编网服务协议》</a>
          <a href="policy.html" style="color: #5C8DDE;">《趣编网隐私政策》</a>
        </p>
      </div>
      <div slot="footer" style="padding:10px 0; text-align: center;">
        <Button class="btn btn-default" style="margin-right: 30px;" @click="m2(true)">注册</Button>
        <Button class="btn btn-empty" @click="m2(false)">取消</Button>
      </div>
    </Modal>

    <Modal v-model="modal.m3" title="提示" class="model" width="480">
      <div style="padding: 10px 88px; font-size: 16px; color:#424753; font-weight: 400; text-align:center;">
        <p>您好，此手机号已自动注册，<br/>初始登录密码为123456。</p>
      </div>
      <div slot="footer" style="padding:10px 0; text-align: center;">
        <Button class="btn btn-default" @click="m3()">确定</Button>
      </div>
    </Modal>

    <Footer></Footer>
  </div>
</template>

<script>
  import '@/assets/js/common'
  import Header from  '@/components/Header'
  import Footer from  '@/components/Footer'
  import moment from 'moment'
  import { publishApi,codeApi } from '@/fetch/api';
  import $ from 'jquery'

  export default {
    components:{
      Header,Footer
    },
    data(){
      return{
        pickerOptions: {
          disabledDate (date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
        videoType: "1",
        videoTime: 1,
        budget: 1,
        endTime: "",
        mobile: "",
        code: "",
        codeBtn:{
          state: 0,
          text: "获取验证码"
        },
        result: {
          state: 0, //0未提交 1提交成功
          num: 3
        },
        user:"",
        modal:{
          m1:false,
          m2:false,
          m3:false,
          agree:false,
          register:0
        }
      }
    },
    mounted(){
      this.user = JSON.parse(localStorage.getItem('userInfo'));

      if(this.user){
        this.mobile = this.user.data.account;
      }
    },
    methods:{
      m1(v){
        if(v){
          this.postPublish(()=>{
            location.href = "project.html";
          });
          this.modal.m1 = false;
        } else {
          // this.$Spin.hide();
          this.modal.m1 = false;
        }
      },
      m2(v){
        if(v){
          // location.href = "register.html";
          // console.log(this.modal.agree)
          if(this.modal.agree){
            this.postPublish(()=>{
              this.modal.m3 = true;
              setTimeout(()=>{
                location.href = "project.html";
              },3000);
            });
            this.modal.m2 = false;
          }
        } else {
          this.modal.m2 = false;
        }
      },
      m3(){
        this.modal.m3 = false;
      },
      onVideoType(t){
        this.videoType = t;
      },
      onVideoTime(t){
        this.videoTime = t;
      },
      onBudget(t){
        this.budget = t;
      },
      onSendCode(){
        let count = 60;
        let timer;

        if(this.mobile == ""){
          alert("请输入联系电话")
          return;
        }

        this.codeBtn.state = 1;
        timer = setInterval(() => {
          if(count<1){
            clearInterval(timer);
            this.codeBtn.state = 0;
            this.codeBtn.text = "获取验证码";
            return;
          }
          --count;
          this.codeBtn.text = count + " s"
        }, 1000)

        this.getCode();
      },
      onSubmitPublish(){
        if(this.endTime == ""){
          alert("请选择时间")
          return;
        }
        if(this.mobile == ""){
          alert("请输入联系电话")
          return;
        }
        if(this.code == ""){
          alert("请输入验证码")
          return;
        }
        // this.$Spin.show();
        if(this.user){
          this.postPublish(()=>{
            location.href = "project.html";
          });
        } else {
          this.verifyAccount((re) => {
            if (re == 0) {
              this.modal.m2 = true;
            } else {
              this.modal.m1 = true;
            }
          });
        }

      },
      postPublish(cb){
        let params = {
          "accountId": 0,
          "type": this.videoType,
          "budget": this.budget,
          "length": this.videoTime,
          "endTime": moment(this.endTime).valueOf(),
          "mobile": this.mobile,
          "code": this.code
        };

        publishApi.postConsumerIntention(params).then((re) => {
          // this.$Spin.hide();
          if(re.status==1){
            localStorage.setItem('userInfo', JSON.stringify(re.data));
            if(cb){cb()}
          } else {
            msgError(re.message);
          }
        });
      },
      verifyAccount(cb){
        let params = {
          phone: this.mobile
        }
        publishApi.verifyAccountExistance(params).then((re) => {
          if(!re.status){
            alert(re.message);
            return;
          }
          cb(re.data);
        });
      },
      getCode(){
        let params = {
          "phone": this.mobile
        };

        codeApi.apiGetSmsCode_4(params).then((re) => {
          if(!re.status){
            alert(re.message);
            return;
          }
        });
      }
    }
  }
</script>

<style scoped>
  dl{ margin: 0 auto; padding: 20px 0; width: 1000px;}
  dl dt,dl dd{ float: left;}
  dl dt{ width: 80px; text-align: right;}
  dl dd{ position: relative; padding-left: 100px; width: 920px;}
  dl dd input{ width: 400px;}
  dl dd .btn{ margin-right: 20px; padding: 9px 0; width: 100px; color: #424753; font-size: 14px; background: #ffffff; border: 1px solid #D8D8D8; border-radius: 2px;}
  dl dd .btn-big{ width: 140px;}
  dl dd .btn:last-child{ margin-right: 0;}
  dl dd .btn:hover{ color: #ffffff; background: #3E87FF; border: 1px solid #3E87FF; opacity: 1;}
  dl dd .btn.active{ color: #ffffff; background: #3E87FF; border: 1px solid #3E87FF;}
  dl dd .tips{ display: inline-block; margin-top: 10px;}
  dl dd .tips a{ font-size: 12px; color: #3E87FF;}

  .form{ margin: 30px 0 58px; background: #ffffff;}
  .title{ padding: 20px; font-size: 16px; color: #424753; font-weight: 600; border-bottom: 1px solid #EEEEEE;}
  .content{ padding: 10px 0; border-bottom: 1px solid #EEEEEE;}
  .content .code input{ margin-right: 20px; width: 250px;}
  .content .code .btn{ width: 130px;}
  .foot{ padding: 29px 0 62px; text-align: center;}
  .foot .btn-default{ margin-right: 30px;}

  .model{}
</style>



// WEBPACK FOOTER //
// App.vue?115f6a00